<template>
  <v-card>
    <v-card-title class="pa-0">
      <v-tabs style="border-top-right-radius: 0.5rem; border-top-left-radius: 0.5rem" grow background-color="primary"
        active-class="subtitle-1 font-weight-bold" center-active :value="coluna_selecionada?.index">
        <v-tab v-for="coluna, idx in colunas" :key="idx" :value="coluna_selecionada?.index"
          @click.prevent="fetchData(coluna, filtroTexto(num_coluna_telao), idx)">
          {{ coluna.dsc_coluna }}
          <span class="tab-count" :class="{ 'tab-count--hidden': !(dataModerada[coluna.num_coluna_telao]?.totalItems > 0) }">
            {{ dataModerada[coluna.num_coluna_telao]?.totalItems > 0 ? dataModerada[coluna.num_coluna_telao].totalItems : '0' }}
          </span>
        </v-tab>

      </v-tabs>
      <v-container class="colab-toolbar-container" fluid>
        <div class="colab-toolbar">
          <v-text-field
            prepend-inner-icon="mdi-magnify"
            solo flat dense hide-details
            placeholder=""
            background-color="surface_tertiary"
            v-model="currentFiltroTexto"
            @input="onChange($event, num_coluna_telao)"
            @keypress.enter="searchModeradas"
            aria-label="Buscar"
            class="colab-search"
          />

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <button class="colab-toolbar-btn colab-toolbar-btn--remove" aria-label="Remover todas as colaborações da coluna" v-bind="attrs" v-on="on" @click.prevent="removerTodasColaboracoesModeradas">
                <v-icon size="18">mdi-arrow-left</v-icon>
              </button>
            </template>
            <span>Remover todas da {{ colunas ? colunas[coluna_selecionada?.index]?.dsc_coluna : 'coluna' }}</span>
          </v-tooltip>
        </div>

        <div @dragover.prevent="handleDragOver" @dragenter.prevent="handleDragOver" @dragleave="handleDragLeave" @drop="handleDrop($event)" class="drop-zone" :class="{ 'drop-zone--active': isDragOver }">
          <template v-if="dataModerada">
            <div v-for="item, idx in dataModerada[num_coluna_telao]?.items" :key="item.id_colaboracao"
              class="card-item-wrapper" :class="{ 'drop-enter': lastDroppedId === item.id_colaboracao }">
              <CardColaboracaoModerada v-model="selectedToTarja" :item="item" :index="idx"
                :dataModerada="dataModerada[num_coluna_telao]" :getColaboracoesModeradas="getColaboracoesModeradas"
                :getColaboracoesAprovadas="getColaboracoesAprovadas" :selectedToTarja="selectedToTarja"
                :num_coluna_telao="num_coluna_telao" :pageModerada="pageModerada"
                :useTarja="!!producaoUsesTarja"
                @change="updateSelectedToTarja" :cod-producao="cod_producao"
                :colunas="colunas" :coluna_selecionada="coluna_selecionada"
                :cod_pasta="cod_pasta"
                :key="item.url_midia_colaboracao"
              />
            </div>
          </template>
        </div>
      </v-container>
    </v-card-title>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { apiClient } from "@/services/api";
import { capitalizeString } from "@/utils/capitalizeString";
import CardColaboracaoModerada from "../Cards/CardColaboracaoModerada.vue";
import { dropTargetMixin } from "@/mixins/dragAndDrop";

export default {
  mixins: [dropTargetMixin],
  components: { CardColaboracaoModerada },
  data() {
    return {
      filtro_texto_moderada: "",
      filtro_texto_moderada_2: "",
      filtro_texto_moderada_3: "",
      isModalImagemAprovadasVisible: false,
      media_type: null,
      midia_url_aprovadas: null,
      selectedToTarja: null,
      num_coluna: 1,
      loading: false,
      debounce: null,
    };
  },
  props: {
    dataModerada: Object,
    cod_producao: Number,
    num_coluna_telao: Number,
    aprovadas_current_page: Number,
    changeColuna: Function,
    pageModerada: Number,
    producaoUsesTarja: Boolean,
    coluna_selecionada: Object,
    changeColunaSelecionada: Function,

  },
  computed: {
    breakpoint() {
      return this.$vuetify.breakpoint.name;
    },
    currentFiltroTexto: {
      get() {
        if (this.num_coluna_telao === 2) return this.filtro_texto_moderada_2;
        if (this.num_coluna_telao === 3) return this.filtro_texto_moderada_3;
        return this.filtro_texto_moderada;
      },
      set(val) {
        if (this.num_coluna_telao === 2) this.filtro_texto_moderada_2 = val;
        else if (this.num_coluna_telao === 3) this.filtro_texto_moderada_3 = val;
        else this.filtro_texto_moderada = val;
      },
    },
    ...mapGetters({
      colunas: 'colaboracoes_moderadas/getterColunasAtivas',
      cod_pasta: 'pastas/getterCodPasta'
    })

  },
  filters: {
    formatedDate(date) {
      return new Date(date).toLocaleDateString();
    },
    formatedHour(date) {
      return new Date(date)
        .toLocaleTimeString()
        .split(":")
        .slice(0, 2)
        .join(":");
    },
  },
  created() {
    // Derive selectedToTarja from the moderated items (flg_exibir_tarja) — no API call needed
    if (this.dataModerada && this.dataModerada[this.num_coluna_telao]) {
      const itemExibido = this.dataModerada[this.num_coluna_telao].items?.find((item) => item.flg_exibir_tarja);
      this.selectedToTarja = itemExibido?.id_colaboracao || null;
    }

    this.filtro_texto_moderada =
      localStorage.getItem("@socialcam/filtro_texto_moderada") || "";
    this.filtro_texto_moderada_2 =
      localStorage.getItem("@socialcam/filtro_texto_moderada_2") || "";
    this.filtro_texto_moderada_3 =
      localStorage.getItem("@socialcam/filtro_texto_moderada_3") || "";
  },
  watch: {
    // Os watchers servem para sincronizar os clients que não foram os autores
    // da mudança de exibição na Tarja. Caso um client altere a exibição da tarja
    // os outros logados na produção são atualizados com base nos watchers abaixo.
    dataModerada: {
      handler(newValue) {
        const itemExibido = newValue[this.num_coluna_telao]?.items?.find((item) => item.flg_exibir_tarja);
        this.selectedToTarja = itemExibido?.id_colaboracao || null;
      }, deep: true
    },
  },
  methods: {
    ...mapActions({
      getColaboracoesAprovadas:
        "colaboracoes_aprovadas/getColaboracoesAprovadas",
      setCopyColaboracoesRecebidas: "colaboracoes_aprovadas/setCopyColaboracoesRecebidas",
      getColaboracoesModeradas:
        "colaboracoes_moderadas/getColaboracoesModeradas",
      incrementTotalItemsExibidas: "colaboracoes_aprovadas/incrementTotalItemsExibidas",
      setPageModerada: "colaboracoes_moderadas/setPageModerada"
    }),
    updateSelectedToTarja(idColaboracao, isExibir) {
      this.selectedToTarja = isExibir ? idColaboracao : null;
    },
    filtroTexto(num_coluna_telao) {
      if (num_coluna_telao === 1) {
        return this.filtro_texto_moderada
      }

      if (num_coluna_telao === 2) {
        return this.filtro_texto_moderada_2
      }
      if (num_coluna_telao === 3) {
        return this.filtro_texto_moderada_3
      }
    },
    async fetchData(coluna, filtro_texto_moderada, indexColuna) {
      this.loading = true
      this.num_coluna = coluna.num_coluna_telao
      this.changeColuna(coluna.num_coluna_telao);
      this.changeColunaSelecionada({ ...coluna, index: indexColuna });
      await this.getColaboracoesModeradas({
        num_coluna_telao: coluna.num_coluna_telao,
        page: 1,
        size: 5,
        cod_producao: this.cod_producao,
        filtro_texto_moderada,
      }).then(() => {
        this.loading = false
      })
    },
    async showModalImagem(midia_url_aprovadas, media_type) {
      this.isModalImagemAprovadasVisible = true;
      this.midia_url_aprovadas = midia_url_aprovadas;
      this.media_type = media_type;
    },
    async closeModalImagem() {
      this.isModalImagemAprovadasVisible = false;
    },
    capitalize(string) {
      return capitalizeString(string);
    },
    async onDropAction(item) {
      const flg_favorita = JSON.parse(localStorage.getItem("@socialcam/flg_favorita")) || false;
      const flg_exibida = JSON.parse(localStorage.getItem("@socialcam/flg_exibida")) || false;
      const page = flg_exibida
        ? this.$store.state.colaboracoes_aprovadas.colaboracoes.colaboracoes_exibidas.currentPage
        : flg_favorita
        ? this.$store.state.colaboracoes_aprovadas.colaboracoes.colaboracoes_favoritas.currentPage
        : this.$store.state.colaboracoes_aprovadas.colaboracoes.colaboracoes_recebidas.currentPage;
      const formData = {
        id_colaboracao: item.id_colaboracao,
        cod_producao: item.cod_producao,
        num_coluna_telao: this.num_coluna_telao,
        dat_moderacao: new Date(),
        dsc_login_moderacao: this.$store.state.users.user.dsc_login_usuario,
      };

      const response = await apiClient.post("/inserirColaboracaoModerada", formData);

      if (response.status === 200) {
        this.setPageModerada(1);
        await this.getColaboracoesAprovadas({
          page,
          size: 5,
          cod_producao: item.cod_producao,
          flg_favorita,
          flg_exibida,
          cod_pasta: this.cod_pasta,
        });
        await this.getColaboracoesModeradas({
          num_coluna_telao: this.num_coluna_telao,
          page: 1,
          size: 5,
          cod_producao: this.cod_producao,
          filtro_texto_moderada: "",
        });
        this.$toast.success("Colaboração movida com sucesso.");
        this.setCopyColaboracoesRecebidas(this.$store.state.colaboracoes_aprovadas.colaboracoes.colaboracoes_recebidas);
      }
    },


    async removerTodasColaboracoesModeradas() {
      try {
        const flag = JSON.parse(localStorage.getItem("@socialcam/flg_favorita")) || false
        const flg_exibida = JSON.parse(localStorage.getItem("@socialcam/flg_exibida")) || false
        const response = await apiClient.delete(
          `removerTodasColaboracoesModeradas/${this.cod_producao}/${this.num_coluna_telao}`
        );

        let totalItems = this.$store.state.colaboracoes_moderadas.colaboracoes_moderadas[this.num_coluna_telao].totalItems

        if (response.status === 200) {
          this.incrementTotalItemsExibidas({ value: totalItems })
          await this.getColaboracoesAprovadas({
            page: 1,
            size: 5,
            cod_producao: this.cod_producao,
            flg_favorita: flag,
            flg_exibida,
            cod_pasta: this.cod_pasta
          });

          await this.getColaboracoesModeradas({
            num_coluna_telao: this.num_coluna_telao,
            page: 1,
            size: 5,
            cod_producao: this.cod_producao,
            filtro_texto_moderada: "",
          });
          this.setCopyColaboracoesRecebidas(this.$store.state.colaboracoes_aprovadas.colaboracoes.colaboracoes_recebidas)
        }
      } catch (error) {
        this.$toast.error(
          "Não foi possível remover as colaborações dessa coluna, tente novamente."
        );
      }
    },

    searchModeradas() {
      clearTimeout(this.debounce);
      this.getColaboracoesModeradas({
        num_coluna_telao: this.num_coluna_telao,
        page: this.dataModerada[this.num_coluna_telao]?.currentPage || 1,
        cod_producao: this.cod_producao,
        size: 5,
        filtro_texto_moderada: this.currentFiltroTexto,
      });
    },
    onChange(e, num_coluna_telao) {
      if (num_coluna_telao === 1) {
        localStorage.setItem("@socialcam/filtro_texto_moderada", e);
      }
      if (num_coluna_telao === 2) {
        localStorage.setItem("@socialcam/filtro_texto_moderada_2", e);
      }
      if (num_coluna_telao === 3) {
        localStorage.setItem("@socialcam/filtro_texto_moderada_3", e);
      }
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.searchModeradas();
      }, 1500);
    },

  },
}
</script>

<style lang="scss" scoped>
.v-tab {
  text-transform: none !important;
  color: #171717 !important;
}

.card-item-wrapper {
  margin-bottom: 8px;
}
</style>